import React, { useEffect, useState } from "react";
import Recent from "./Recent";
import Allocated from "./Allocated";
import Closed from "./Closed";

const SiteNotification = () => {
  const [activeTab, setActiveTab] = useState("Recent");
  const [sites, setSites] = useState(null);
  const [companies, setCompanies] = useState(null);

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("Notifications", JSON.stringify(type));
  };

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && (
          <Recent
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Allocated" && (
          <Allocated
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Closed" && (
          <Closed
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
      </div>
    </div>
  );
};

export default SiteNotification;
